//
//  utils/logError.ts
//
//  isana.net,inc. Proprietary and Confidential
//
import axios from "axios";

// axiosエラーはconfig.headers（x-api-key）やconfig.data（トークン等）を含むため、
// オブジェクト全体をconsoleに出力せず、メッセージとステータスのみを出力する
export const logApiError = (error: unknown): void => {
  if (axios.isAxiosError(error)) {
    console.error(
      `API error: ${error.message} (status=${error.response?.status ?? "none"})`
    );
    return;
  }
  // throwされた文字列や独自toStringに機密値が含まれうるため、Error以外は固定文言にする
  console.error(error instanceof Error ? error.message : "Unknown API error");
};
